"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_CapabilityStatement_Rest = exports.CapabilityStatement_RestModeKind = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_markdown_1 = require("../Scalar/RTTI_markdown");
var RTTI_CapabilityStatement_Security_1 = require("./RTTI_CapabilityStatement_Security");
var RTTI_CapabilityStatement_Resource_1 = require("./RTTI_CapabilityStatement_Resource");
var RTTI_CapabilityStatement_Interaction1_1 = require("./RTTI_CapabilityStatement_Interaction1");
var RTTI_CapabilityStatement_SearchParam_1 = require("./RTTI_CapabilityStatement_SearchParam");
var RTTI_CapabilityStatement_Operation_1 = require("./RTTI_CapabilityStatement_Operation");
var RTTI_canonical_1 = require("../Scalar/RTTI_canonical");
var CapabilityStatement_RestModeKind;
(function (CapabilityStatement_RestModeKind) {
    CapabilityStatement_RestModeKind["_client"] = "client";
    CapabilityStatement_RestModeKind["_server"] = "server";
})(CapabilityStatement_RestModeKind = exports.CapabilityStatement_RestModeKind || (exports.CapabilityStatement_RestModeKind = {}));
var EnumType_1 = require("../../EnumType");
exports.RTTI_CapabilityStatement_Rest = t.recursion('ICapabilityStatement_Rest', function () {
    return t.partial({
        id: t.string,
        extension: t.array(RTTI_Extension_1.RTTI_Extension),
        modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
        mode: (0, EnumType_1.createEnumType)(CapabilityStatement_RestModeKind, 'CapabilityStatement_RestModeKind'),
        _mode: RTTI_Element_1.RTTI_Element,
        documentation: RTTI_markdown_1.RTTI_markdown,
        _documentation: RTTI_Element_1.RTTI_Element,
        security: RTTI_CapabilityStatement_Security_1.RTTI_CapabilityStatement_Security,
        resource: t.array(RTTI_CapabilityStatement_Resource_1.RTTI_CapabilityStatement_Resource),
        interaction: t.array(RTTI_CapabilityStatement_Interaction1_1.RTTI_CapabilityStatement_Interaction1),
        searchParam: t.array(RTTI_CapabilityStatement_SearchParam_1.RTTI_CapabilityStatement_SearchParam),
        operation: t.array(RTTI_CapabilityStatement_Operation_1.RTTI_CapabilityStatement_Operation),
        compartment: t.array(RTTI_canonical_1.RTTI_canonical)
    });
});
//# sourceMappingURL=RTTI_CapabilityStatement_Rest.js.map